import React, { Component } from 'react';

import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import SimilarAuthorsListItem from './SimilarAuthorsListItem';
import ReadALikeFooter from 'react/card/ReadALikeFooter';

import './similarAuthorsView.less';

class SimilarAuthorsView extends Component {
    renderAuthors() {
        var authorList = this.props.cardModel.map((author) => {
            return (
                <SimilarAuthorsListItem key={author.uniqueId} author={author} onItemClick={this.props.onItemClick} />
            );
        });

        return authorList;
    }

    render() {
        return (
            <Card>
                <CardTitle title="Similar Authors" />
                <div className="similar-authors-list">
                    {this.renderAuthors()}
                </div>
                <ReadALikeFooter onNext={this.props.onNext} onPrevious={this.props.onPrevious} />
            </Card>
        );
    }
}

export default SimilarAuthorsView;



// WEBPACK FOOTER //
// ./src/react/views/similarAuthors/SimilarAuthorsView.jsx